import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import * as Strings from '../constants';

export default () => (
  <footer>
    <Row>
      <Col>
        <p className="disclaimer" dangerouslySetInnerHTML={{ __html: Strings.Disclaimer }} />
        <p className="disclaimer" dangerouslySetInnerHTML={{ __html: Strings.MoreInfo }} />
      </Col>
      <Col className="text-right">
        <a
         href="https://graduateinstitute.ch/ccdp"
         title="Go to institute website"
         target="_blank">
           <img
            className="logo"
            src="/img/logo_CCDP_sw.png"
            alt="Logo THe Graduate Institute"
          />
        </a>
      </Col>
    </Row>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/footer.js